import { render } from "./SnapDocs.vue?vue&type=template&id=8c15184c&scoped=true"
import script from "./SnapDocs.vue?vue&type=script&lang=js"
export * from "./SnapDocs.vue?vue&type=script&lang=js"

import "./SnapDocs.vue?vue&type=style&index=0&id=8c15184c&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c15184c"]])

export default __exports__